import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";
import { formatXAF } from "@/lib/api";

const I18nCtx = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("bkm_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("bkm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path, vars = {}) => {
      const val = path.split(".").reduce((o, k) => (o ? o[k] : undefined), translations[lang]);
      if (typeof val !== "string") return path;
      return val.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ""));
    },
    [lang],
  );

  const tErr = useCallback(
    (code) => {
      const base = (code || "unknown_error").split(":")[0];
      const msg = translations[lang].errors[base] || translations[lang].errors.unknown_error;
      if (base === "campay_error" && code.includes(":")) return `${msg} (${code.split(":").slice(1).join(":")})`;
      if (base === "wager_required") {
        const [, rest, ok] = code.split(":");
        return msg.replace("{r}", formatXAF(+rest || 0, lang)).replace("{w}", formatXAF(+ok || 0, lang));
      }
      return msg;
    },
    [lang],
  );

  return <I18nCtx.Provider value={{ lang, setLang, t, tErr }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
